/// <reference types="vite/client" />

import React from 'react';
import ReactDOMClient from 'react-dom/client';
import App from './App';
// Sentry import previously here is now DELETED.
// import './index.css'; // Optional: if we add global styles later

// Sentry initialization block previously here is now DELETED.
// Sentry related variables like sentryDSN, sentryInitialized previously here are now DELETED.

// console.log('Sentry frontend initialization code fully removed from main.tsx as per user directive.'); // DELETED THIS LINE

const container = document.getElementById('root');

if (container) {
  const root = ReactDOMClient.createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error("Failed to find the root element with ID 'root'. React app could not be mounted.");
  // Conditional Sentry.captureMessage call previously here is now DELETED.
}
// Rewrite Count: 7